export default __webpack_public_path__ + "static/media/PED-icon.343d11fa.svg";